// Asset-Helper für einfachen Import und Pfad-Management

export const ASSETS = {
  // Logos und Branding
  logo: '/assets/images/logo.svg',
  logoWebp: '/assets/images/logo.webp',
  
  // Navigation Icons
  hamburgerIcon: '/assets/images/hamburger-icon.svg',
  closeIcon: '/assets/images/close-icon.svg',
  
  // Social Media Icons
  facebook: '/assets/images/facebook.svg',
  instagram: '/assets/images/instagram.svg',
  telegram: '/assets/images/telegram.svg',
  twitter: '/assets/images/twitter.svg',
  
  // Contact Icons
  phone: '/assets/images/phone.svg',
  contactTelegram: '/assets/images/contact/telegram.svg',
  contactWhatsapp: '/assets/images/contact/whatsapp.svg',
  
  // Background Assets
  background: '/assets/images/background.svg',
  pattern: '/assets/images/Pattern.svg',
  gradient: '/assets/images/gradient.webp',
  gradient2: '/assets/images/gradient2.png',
  
  // UI Elements
  rightArrow: '/assets/images/rightArrow.svg',
  leftArrow: '/assets/images/left-arrow.png',
  rightArrowPng: '/assets/images/right-arrow.png',
  moreArrow: '/assets/images/moreArrow.svg',
  circle: '/assets/images/circle.svg',
  rectangle: '/assets/images/rectangle.svg',
  star: '/assets/images/star.svg',
  frame632: '/assets/images/Frame%20632.svg',
  frame633: '/assets/images/Frame%20633.svg',
  
  // Technology Icons
  flutter: '/assets/images/flutter.svg',
  
  // Decorative Elements
  clouds: '/assets/images/Clouds.svg',
  aeroplane: '/assets/images/Aeroplane.svg',
  planets: '/assets/images/planets.png',
  
  // Data Protection
  dataProtectionBg: '/assets/images/data-protection-bg.png',
  cookieIcon: '/assets/images/cookie-icon.svg',
} as const;

export const LOGO_ASSETS = {
  allsafe: '/assets/images/logos/allsafe.webp',
  channels42: '/assets/images/logos/42channels.webp',
  ideenbutze: '/assets/images/logos/ideenbutze.webp',
  lernkarten: '/assets/images/logos/lernkarten.webp',
  m8werk: '/assets/images/logos/m8werk.webp',
  nextserve: '/assets/images/logos/nextserve.webp',
  osnalive: '/assets/images/logos/osnalive.webp',
  presseaugsburg: '/assets/images/logos/presseaugsburg.webp',
  serviceunion: '/assets/images/logos/serviceunion.webp',
  spoord: '/assets/images/logos/spoord.webp',
} as const;

export const MOCKUP_ASSETS = {
  mockup1: '/assets/images/mockups/mockup1.webp',
  mockup2: '/assets/images/mockups/mockup2.webp',
  mockup3: '/assets/images/mockups/mockup3.webp',
  mockup4: '/assets/images/mockups/mockup4.webp',
} as const;

export const HOME_REF_ASSETS = {
  browser: '/assets/images/homeRef/browser.webp',
  browser1: '/assets/images/homeRef/browser-1.webp',
  browser2: '/assets/images/homeRef/browser-2.webp',
  browser3: '/assets/images/homeRef/browser-3.webp',
  browser4: '/assets/images/homeRef/browser-4.webp',
  browser5: '/assets/images/homeRef/browser-5.webp',
  browser6: '/assets/images/homeRef/browser-6.webp',
  browser7: '/assets/images/homeRef/browser-7.webp',
  browser8: '/assets/images/homeRef/browser-8.webp',
  browser9: '/assets/images/homeRef/browser-9.webp',
} as const;

// Hilfsfunktion für Asset-Pfade
export const getAssetPath = (assetName: keyof typeof ASSETS): string => {
  return ASSETS[assetName];
};

export const getLogoPath = (logoName: keyof typeof LOGO_ASSETS): string => {
  return LOGO_ASSETS[logoName];
};

export const getMockupPath = (mockupName: keyof typeof MOCKUP_ASSETS): string => {
  return MOCKUP_ASSETS[mockupName];
};

export const getHomeRefPath = (refName: keyof typeof HOME_REF_ASSETS): string => {
  return HOME_REF_ASSETS[refName];
};
